import { createContext, useContext } from 'react';
import type { Context } from 'react';

export type DataContextValue = {
	basePath: string;
};

export const DataContext: Context<DataContextValue> = createContext<DataContextValue>({
	basePath: '',
});

export function useDataContext(): DataContextValue {
	return useContext(DataContext);
}
